import type { ReactNode } from 'react'

interface EntityHeaderProps {
  name: string
  type: string
  /** Right-aligned content, e.g. an overall progress readout. */
  rightSlot?: ReactNode
  /**
   * A line directly under the name, for something the reader needs at a glance rather
   * than a click away — the entity's reporting link, for instance. The header keeps its
   * 58px single-row shape when this is absent.
   */
  subline?: ReactNode
}

export function EntityHeader({ name, type, rightSlot, subline }: EntityHeaderProps) {
  const titleRow = (
    <div className="flex items-baseline gap-3">
      <h1 className="font-jakarta font-bold text-white" style={{ fontSize: 20, lineHeight: '24px' }}>
        {name}
      </h1>
      <span className="text-text-support" style={{ fontSize: 14 }}>|</span>
      <span className="font-jakarta text-text-support" style={{ fontSize: 14 }}>
        {type}
      </span>
    </div>
  )

  if (!subline) {
    return (
      <div
        className="bg-background-main flex items-center justify-between border-0.5 border-border-main"
        style={{ height: 58, padding: '0 20px' }}
      >
        {titleRow}
        {rightSlot}
      </div>
    )
  }

  return (
    <div
      className="bg-background-main flex items-start justify-between border-0.5 border-border-main"
      style={{ minHeight: 58, padding: '12px 20px' }}
    >
      <div className="flex flex-col" style={{ gap: 6, minWidth: 0 }}>
        {titleRow}
        {subline}
      </div>
      {rightSlot}
    </div>
  )
}
